import { useState } from "react";
import { Facebook } from "lucide-react";

// Shared Facebook widget, styled to match InstagramWidget's card shell.
//
// Why no iframe: Facebook's Page Plugin posts feed is login-walled for
// logged-out visitors (renders blank), and its page-card variant renders as a
// cramped, cropped iframe that doesn't match the other widgets. Since we don't
// need scrolling posts, we render a clean native card instead: the real page
// avatar is loaded live from Facebook's graph picture endpoint (no token
// required), with a graceful fallback if it can't load.
const PAGE_URL = "https://www.facebook.com/tastebudsbyAnubhi/";
const PAGE_NAME = "TastebudsByAnubhi";
const AVATAR_URL =
  "https://graph.facebook.com/tastebudsbyanubhi/picture?type=large&width=320&height=320";

export default function FacebookWidget() {
  const [avatarFailed, setAvatarFailed] = useState(false);

  return (
    <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm bg-white flex flex-col" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100">
        <div className="w-6 h-6 rounded-full bg-[#1877F2] flex items-center justify-center shrink-0">
          <Facebook className="w-3.5 h-3.5 text-white" />
        </div>
        <span className="text-[13px] font-semibold text-gray-800">@tastebudsbyanubhi</span>
      </div>
      <div className="flex-1 min-h-[340px] flex flex-col items-center justify-center text-center px-6 py-10 bg-gradient-to-b from-[#1877F2]/5 via-white to-white">
        {avatarFailed ? (
          <div className="w-20 h-20 rounded-full bg-[#1877F2]/10 border-2 border-[#1877F2]/20 flex items-center justify-center mb-4">
            <Facebook className="w-9 h-9 text-[#1877F2]" />
          </div>
        ) : (
          <img
            src={AVATAR_URL}
            alt="TastebudsByAnubhi Facebook page profile photo"
            className="w-20 h-20 rounded-full object-cover shadow-md ring-4 ring-[#1877F2]/15 mb-4"
            onError={() => setAvatarFailed(true)}
          />
        )}
        <p className="text-base font-bold text-gray-900">{PAGE_NAME}</p>
        <p className="text-[13px] text-gray-400 mt-0.5">@tastebudsbyanubhi</p>
        <p className="text-[13px] text-gray-500 mt-3 leading-relaxed max-w-[240px]">
          Follow us on Facebook for the latest DFW food finds, events, and community stories.
        </p>
      </div>
      <div className="px-4 py-3 border-t border-gray-100 flex justify-center">
        <a
          href={PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-5 py-2.5 rounded-full text-white text-sm font-semibold transition-transform hover:scale-105 active:scale-95"
          style={{ background: "linear-gradient(45deg, #1877F2, #0C63D4)" }}
        >
          <Facebook className="w-4 h-4" />
          Follow on Facebook
        </a>
      </div>
    </div>
  );
}
